import { DeckCard } from "@apiserver-rest/ponder-data-client-base";

export function getDeckCardName(deckCard: DeckCard): string {
    if (deckCard.card.item.data?.magic) {
        return deckCard.card.item.data!.magic!.faces![0].name!;
    }

    return deckCard.card.item.name!;
}